import { Injectable, inject } from '@angular/core';
import { CommandRegistryService } from '../../../../../../core/services/command-registry.service';
import type { CmdkItem } from '../../models/cmdk.model';
import type { CmdkProvider, CmdkProviderContext } from '../../models/cmdk-provider';
import { isNavCommand, toActionItem, visibleCommands } from './command.source';

/**
 * RESPONSIBILITY: the "Actions" scope, and the "Suggested actions" block the
 * palette opens on — everything the five registry contributors publish that is
 * not a navigation destination.
 *
 * Local and synchronous, zero network. Each command's own `visible(ctx)`
 * carries its action gating, so a viewer never sees an action they cannot
 * run.
 *
 * `idle: 'browse'` — this is the provider that makes an empty palette useful.
 * The design's idle state is "Suggested actions" over "Recent", and the
 * registry's `contextBoost` already orders them by where the viewer is.
 *
 * BACKEND CONTRACT: none.
 */
@Injectable({ providedIn: 'root' })
export class CmdkActionProvider implements CmdkProvider {
  private readonly registry = inject(CommandRegistryService);

  readonly id = 'action';
  readonly kind = 'action' as const;
  readonly scope = 'actions' as const;
  readonly minQueryLength = 0;
  readonly idle = 'browse' as const;

  isEnabled(): boolean {
    return true;
  }

  browse(ctx: CmdkProviderContext): CmdkItem[] {
    return this.collect(ctx, true);
  }

  search(ctx: CmdkProviderContext): CmdkItem[] {
    return this.collect(ctx, false);
  }

  private collect(ctx: CmdkProviderContext, primaryOnly: boolean): CmdkItem[] {
    return visibleCommands(this.registry, ctx, { primaryOnly })
      .filter(command => !isNavCommand(command))
      .map(toActionItem);
  }
}
